module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-role-degrade/user-role-degrade.component.scss
// module id = ./src/app/user-role-degrade/user-role-degrade.component.scss
// module chunks = main